import { Box, Tooltip, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";

import StatusCell from "./StatusCell";

const handleActions = (params, setSelectedDevice, handleEdit, setOpen) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      height: "100%",
      minHeight: "52px",
    }}
  >
    {/* Edit Button - Always visible with icon and text */}

    {params.row.allow_edit === 1 && (

    
    <Box
      display="flex"
      alignItems="center"
      sx={{
        backgroundColor: "#FAFAFA",
        borderRadius: "6px",
        border: "1px solid #E0E0E0",
        padding: "4px 0",
        gap: 1,
      }}
    >
      <Tooltip title="Edit">
        <Box
          display="flex"
          alignItems="center"
          sx={{
            cursor: "pointer",
            padding: "4px 8px",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: "#F0F0F0",
            },
          }}
          onClick={() => handleEdit(params.row)}
        >
          <EditIcon fontSize="small" color="primary" />
          <Typography
            variant="body2"
            sx={{
              ml: 1,
              fontSize: "13px",
              fontWeight: 500,
              color: "#1976D2",
            }}
          >
            Edit
          </Typography>
        </Box>
        
      </Tooltip>
    </Box>
    )}
    {/* Archive Button - Conditionally visible with icon and text */}
    {params.row.device_type !== "Archived" && (
      <>
        <Box
          sx={{
            height: "20px",
            width: "1px",
            backgroundColor: "#E0E0E0",
          }}
        />
        <Box
          display="flex"
          alignItems="center"
          sx={{
            backgroundColor: "#FAFAFA",
            borderRadius: "6px",
            border: "1px solid #E0E0E0",
            padding: "4px 8px",
            gap: 1,
          }}
        >
          <Tooltip title="Archive">
            <Box
              display="flex"
              alignItems="center"
              sx={{
                cursor: "pointer",
                padding: "4px 8px",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#F0F0F0",
                },
              }}
              onClick={() => {
                setSelectedDevice(params.row);
                setOpen(true);
              }}
            >
              <DeleteForeverIcon fontSize="small" color="error" />
              <Typography
                variant="body2"
                sx={(theme) => ({
                  ml: 1,
                  fontSize: "13px",
                  fontWeight: 500,
                  color: theme.palette.error.main,
                })}
              >
                Archive
              </Typography>
            </Box>
          </Tooltip>
        </Box>
      </>
    )}
  </Box>
);

export const getColumns = (
  setSelectedDevice,
  setOpenStatusChangeModal,
  handleEdit,
  setOpen
) => [
  {
    field: "name",
    headerName: "Device Name",
    width: 200,
  },
  {
    field: "imei",
    headerName: "Device ID",
    width: 250,
  },
  {
    field: "active",
    headerName: "Activation",
    width: 220,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <StatusCell
        params={params}
        setSelectedRow={setSelectedDevice}
        setOpenStatusChangeModal={setOpenStatusChangeModal}
      />
    ),
  },
  {
    field: "employeeName",
    headerName: "Employee Name",
    width: 200,
  },
  {
    field: "type",
    headerName: "Type",
    width: 150,
  },
  {
    field: "device_notify_token",
    headerName: "Device Notify Token",
    width: 200,
  },
  {
    field: "action",
    headerName: "Action",
    width: 230,
    sortable: false,
    renderCell: (params) =>
      handleActions(params, setSelectedDevice, handleEdit, setOpen),
  },
];
